import { Copy } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/i18n";

export const CopyButton = ({ value, label, testId, light = false }) => {
  const { t } = useLang();
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = value;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    toast.success(t.common.copied);
  };
  return (
    <button type="button" onClick={copy} data-testid={testId} className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-colors duration-300 ${light ? "bg-white/15 text-white hover:bg-white/25" : "bg-[var(--green-pale)] text-[var(--green-deep)] hover:bg-[var(--green-deep)] hover:text-white"}`}>
      <Copy size={14} /> {label}
    </button>
  );
};
